export class ProgramAreaSearchResult {
    public id: number;
    public areaTypeId: number;
    public name: string;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/common/program-area-search-result.ts